import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tw-p-4 sm:tw-p-6" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "tw-mb-4 tw-rounded-xl tw-border tw-border-emerald-200 tw-bg-emerald-50 tw-px-4 tw-py-3 tw-text-sm tw-text-emerald-900"
}
const _hoisted_4 = { class: "tw-mb-4 tw-text-left" }
const _hoisted_5 = { class: "tw-mt-1 tw-text-sm tw-text-slate-600" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "tw-overflow-x-auto" }
const _hoisted_9 = { class: "tw-min-w-full tw-border-separate tw-border-spacing-0 tw-text-left" }
const _hoisted_10 = { class: "tw-divide-y tw-divide-slate-200/70" }
const _hoisted_11 = { class: "tw-flex tw-items-stretch tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-shadow-sm tw-shadow-slate-900/5 tw-overflow-hidden" }
const _hoisted_12 = ["readonly"]
const _hoisted_13 = { class: "tw-flex tw-items-stretch tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-shadow-sm tw-shadow-slate-900/5 tw-overflow-hidden" }
const _hoisted_14 = ["readonly"]
const _hoisted_15 = { class: "tw-flex tw-items-stretch tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-shadow-sm tw-shadow-slate-900/5 tw-overflow-hidden" }
const _hoisted_16 = ["readonly"]
const _hoisted_17 = { class: "tw-flex tw-items-stretch tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-shadow-sm tw-shadow-slate-900/5 tw-overflow-hidden" }
const _hoisted_18 = ["readonly"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[16] || (_cache[16] = [
          _createElementVNode("p", null, "Loading", -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.saveMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.saveMessage), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "tw-text-lg tw-font-semibold tw-text-slate-900" }, "Terminal Logins", -1)),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.canEditTerminalLogins)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Credentials are only editable when you click the wrench."))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, "Only company admins can edit terminal credentials."))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("table", _hoisted_9, [
        _cache[21] || (_cache[21] = _createElementVNode("thead", null, [
          _createElementVNode("tr", { class: "tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500" }, [
            _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-bg-white/80 tw-backdrop-blur tw-px-3 tw-py-3" }, "Terminal"),
            _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-bg-white/80 tw-backdrop-blur tw-px-3 tw-py-3" }, "Username"),
            _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-bg-white/80 tw-backdrop-blur tw-px-3 tw-py-3" }, "Password")
          ])
        ], -1)),
        _createElementVNode("tbody", _hoisted_10, [
          _createElementVNode("tr", null, [
            _cache[18] || (_cache[18] = _createElementVNode("td", { class: "tw-px-3 tw-py-3 tw-text-sm tw-font-semibold tw-text-slate-900" }, "ETS", -1)),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_11, [
                (_ctx.canEditTerminalLogins)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.editingTerminal !== 'ETS' || _ctx.editingField !== 'username')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "tw-inline-flex tw-items-center tw-justify-center tw-px-3 tw-text-slate-600 hover:tw-bg-white",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startEdit('ETS', 'username'))),
                            title: "Edit ETS",
                            "aria-label": "Edit ETS"
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "wrench",
                              class: "tw-h-4 tw-w-4"
                            })
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "tw-inline-flex tw-items-center tw-justify-center tw-px-3 tw-text-slate-900 hover:tw-bg-white",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveEdit('ETS', 'username'))),
                              "aria-label": "Save"
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "check",
                                class: "tw-h-4 tw-w-4"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "tw-inline-flex tw-items-center tw-justify-center tw-px-3 tw-text-slate-600 hover:tw-bg-white",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args))),
                              "aria-label": "Cancel"
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "xmark",
                                class: "tw-h-4 tw-w-4"
                              })
                            ])
                          ], 64))
                    ], 64))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.terminalLoginEtsUsername) = $event)),
                  class: "terminal-login-input tw-flex-1 tw-min-w-0 tw-border-0 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-outline-none",
                  type: "text",
                  placeholder: "Username",
                  readonly: !_ctx.canEditTerminalLogins || _ctx.editingTerminal !== 'ETS' || _ctx.editingField !== 'username'
                }, null, 8, _hoisted_12), [
                  [_vModelText, _ctx.terminalLoginEtsUsername]
                ])
              ])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_13, [
                (_ctx.canEditTerminalLogins)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.editingTerminal !== 'ETS' || _ctx.editingField !== 'password')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "tw-inline-flex tw-items-center tw-justify-center tw-px-3 tw-text-slate-600 hover:tw-bg-white",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.startEdit('ETS', 'password'))),
                            title: "Edit ETS",
                            "aria-label": "Edit ETS"
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "wrench",
                              class: "tw-h-4 tw-w-4"
                            })
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "tw-inline-flex tw-items-center tw-justify-center tw-px-3 tw-text-slate-900 hover:tw-bg-white",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveEdit('ETS', 'password'))),
                              "aria-label": "Save"
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "check",
                                class: "tw-h-4 tw-w-4"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "tw-inline-flex tw-items-center tw-justify-center tw-px-3 tw-text-slate-600 hover:tw-bg-white",
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args))),
                              "aria-label": "Cancel"
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "xmark",
                                class: "tw-h-4 tw-w-4"
                              })
                            ])
                          ], 64))
                    ], 64))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.terminalLoginEtsPassword) = $event)),
                  class: "terminal-login-input tw-flex-1 tw-min-w-0 tw-border-0 tw-bg-transparent tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-outline-none",
                  type: "password",
                  placeholder: "Password",
                  readonly: !_ctx.canEditTerminalLogins || _ctx.editingTerminal !== 'ETS' || _ctx.editingField !== 'password'
                }, null, 8, _hoisted_14), [
                  [_vModelText, _ctx.terminalLoginEtsPassword]
                ])
              ])
            ])
          ]),
          _createElementVNode("tr", null, [
            _cache[19] || (_cache[19] = _createElementVNode("td", { class: "tw-px-3 tw-py-3 tw-text-sm tw-font-semibold tw-text-slate-900" }, "OICT/SSA", -1)),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_15, [
                (_ctx.canEditTerminalLogins)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.editingTerminal !== 'SSA' || _ctx.editingField !== 'username')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "tw-inline-flex tw-items-center tw-justify-center tw-px-3 tw-text-slate-600 hover:tw-bg-white",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.startEdit('SSA', 'username'))),
                            title: "Edit SSA",
                            "aria-label": "Edit SSA"
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "wrench",
                              class: "tw-h-4 tw-w-4"
                            })
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "tw-inline-flex tw-items-center tw-justify-center tw-px-3 tw-text-slate-900 hover:tw-bg-white",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.saveEdit('SSA', 'username'))),
                              "aria-label": "Save"
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "check",
                                class: "tw-h-4 tw-w-4"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "tw-inline-flex tw-items-center tw-justify-center tw-px-3 tw-text-slate-600 hover:tw-bg-white",
                              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args))),
                              "aria-label": "Cancel"
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "xmark",
                                class: "tw-h-4 tw-w-4"
                              })
                            ])
                          ], 64))
                    ], 64))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.terminalLoginSsaUsername) = $event)),
                  class: "terminal-login-input tw-flex-1 tw-min-w-0 tw-border-0 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-outline-none",
                  type: "text",
                  placeholder: "Username",
                  readonly: !_ctx.canEditTerminalLogins || _ctx.editingTerminal !== 'SSA' || _ctx.editingField !== 'username'
                }, null, 8, _hoisted_16), [
                  [_vModelText, _ctx.terminalLoginSsaUsername]
                ])
              ])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_17, [
                (_ctx.canEditTerminalLogins)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.editingTerminal !== 'SSA' || _ctx.editingField !== 'password')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "tw-inline-flex tw-items-center tw-justify-center tw-px-3 tw-text-slate-600 hover:tw-bg-white",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.startEdit('SSA', 'password'))),
                            title: "Edit SSA",
                            "aria-label": "Edit SSA"
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "wrench",
                              class: "tw-h-4 tw-w-4"
                            })
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "tw-inline-flex tw-items-center tw-justify-center tw-px-3 tw-text-slate-900 hover:tw-bg-white",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveEdit('SSA', 'password'))),
                              "aria-label": "Save"
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "check",
                                class: "tw-h-4 tw-w-4"
                              })
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "tw-inline-flex tw-items-center tw-justify-center tw-px-3 tw-text-slate-600 hover:tw-bg-white",
                              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args))),
                              "aria-label": "Cancel"
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "xmark",
                                class: "tw-h-4 tw-w-4"
                              })
                            ])
                          ], 64))
                    ], 64))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.terminalLoginSsaPassword) = $event)),
                  class: "terminal-login-input tw-flex-1 tw-min-w-0 tw-border-0 tw-bg-transparent tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-outline-none",
                  type: "password",
                  placeholder: "Password",
                  readonly: !_ctx.canEditTerminalLogins || _ctx.editingTerminal !== 'SSA' || _ctx.editingField !== 'password'
                }, null, 8, _hoisted_18), [
                  [_vModelText, _ctx.terminalLoginSsaPassword]
                ])
              ])
            ])
          ]),
          _cache[20] || (_cache[20] = _createElementVNode("tr", null, [
            _createElementVNode("td", { class: "tw-px-3 tw-py-3 tw-text-sm tw-font-semibold tw-text-slate-900" }, "Trapac"),
            _createElementVNode("td", {
              colspan: "2",
              class: "tw-px-3 tw-py-3 tw-text-sm tw-text-slate-700"
            }, "No Login needed for Trapac")
          ], -1))
        ])
      ])
    ])
  ]))
}